// extracted by mini-css-extract-plugin
module.exports = {"similar-products__title":"similar-products_similar-products__title__Y2ANc","similar-products__empty":"similar-products_similar-products__empty__cjZTM"};